// Styles that turn MI6's Modal into a full-height panel on the right of the
// builder, shared by the Document settings and Publish & sharing panels

export const PANEL_OVERLAY = {
  backgroundColor: 'rgba(0, 0, 0, 0.35)',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  justifyContent: 'flex-end',
  padding: 0
}

export const PANEL_CONTENT = {
  position: 'static',
  display: 'flex',
  flexDirection: 'column',
  width: 480,
  maxWidth: '100%',
  height: '100%',
  inset: 'auto',
  margin: 0,
  padding: 0,
  border: 'none',
  borderRadius: 0,
  background: 'transparent',
  overflow: 'visible'
}

export const PANEL_BODY = {
  flex: 1,
  borderRadius: 0,
  padding: 24,
  minWidth: 0
}
